import { useEffect, useState } from 'react'
import { useAppSelector } from 'reduxTyped'

import { SidebarViewState } from 'apps/aiAutomation/components/Layout/lib/types'
import { AiAutomationLayoutSelectors } from 'apps/aiAutomation/store/layout'
import { useIsChanged } from 'utils/commonHooks'

/**
 * A view might be opened with different payload that might be saved in its local state.
 *
 * When a user quickly opens a view, closes sidebar and opens the same view with different payload,
 * the local state of a view is not reset which may lead to bugs.
 *
 * This hook introduces a unique id for a view, that is changed when the manipulations above are
 * applied, and this, automatically destroys and mounts a view ensuring that the local state will
 * be reset without necessity of doing it manually in each view.
 */
export const useViewKey = (viewState: SidebarViewState) => {
  const isSidebarOpen = useAppSelector(AiAutomationLayoutSelectors.getIsSidebarOpen)

  const isSidebarChanged = useIsChanged(isSidebarOpen)
  const viewStateChanged = useIsChanged(viewState)

  const [key, setKey] = useState(0)

  useEffect(() => {
    if (isSidebarOpen && isSidebarChanged && viewState === 'open' && !viewStateChanged) {
      setKey((prev) => prev + 1)
    }
  }, [viewState, isSidebarOpen, isSidebarChanged, viewStateChanged])

  return key
}
